import React from 'react'

const ConferencesFoundation = () => {
  return (
    <div className="conferences-content main">Foundation</div>
  )
}

export default ConferencesFoundation;
